import escapeRegExp from "./escapeRegexp";

export const lowerMatch = (s1, s2) => {
  const regex = new RegExp(escapeRegExp(s2.toLowerCase()));
  return regex.test(s1.toLowerCase());
};

export const lowerMatch2 = (s1, s2) => {
  return escapeRegExp(s1).toLowerCase().match(escapeRegExp(s2).toLowerCase());
};

export const containsEscaped = (str1, str2) => {
  const escapedStr2 = str2.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(escapedStr2);
  return regex.test(str1.toLowerCase());
};
